
import {
  BuildKitPartNumber, PartNumberDrawingBlobMap,
} from "../../../shared/models/build-kit.model";
import {StateStatus} from "../../../shared/models/state-status.models";
import {createReducer, on} from "@ngrx/store";
import {
  loadPartNumberDrawingBlob, loadPartNumberDrawingBlobFailure, loadPartNumberDrawingBlobSuccess,
  loadPartNumbers,
  loadPartNumbersEmpty, loadPartNumbersFailure,
  loadPartNumbersNoAction,
  loadPartNumbersSuccess
} from "./build-kit-part-number.action";


export interface BuildKitPartNumberState {
  buildKitPartNumbers: BuildKitPartNumber[];
  partNumberDrawingBlobMap: any;
  partNumberStatus: StateStatus;
  error: any;
}

export const initialState: BuildKitPartNumberState = {
  buildKitPartNumbers: [],
  partNumberDrawingBlobMap: {} as any,
  partNumberStatus: 'pending' as StateStatus,
  error: null
};

export const buildKitPartNumberReducer = createReducer(
  initialState,
  on(loadPartNumbers, (state): BuildKitPartNumberState => ({ ...state, partNumberStatus: 'loading' as StateStatus })),
  on(loadPartNumbersNoAction, (state): BuildKitPartNumberState => ({ ...state, partNumberStatus: 'loadSuccess' as StateStatus })),
  on(loadPartNumbersSuccess, (state, { buildKitPartNumber }): BuildKitPartNumberState => ({
    ...state,
    buildKitPartNumbers: addOrUpdateBuildKitPartNumbers(state, buildKitPartNumber),
    error: null,
    partNumberStatus: 'loadSuccess' as StateStatus,
  })),
  on(loadPartNumbersEmpty, (state): BuildKitPartNumberState => ({
    ...state,
    buildKitPartNumbers: [],
    error: null,
    partNumberStatus: 'loadSuccess' as StateStatus,
  })),
  on(loadPartNumbersFailure, (state, { error }): BuildKitPartNumberState => ({
    ...state,
    error: error,
    partNumberStatus: 'error' as StateStatus,
  })),

  on(loadPartNumberDrawingBlob, (state, { pdfDrawingFileKey }): BuildKitPartNumberState => ({
    ...state,
    partNumberDrawingBlobMap: {
      ...state.partNumberDrawingBlobMap,
      [pdfDrawingFileKey]: partNumberDrawingBlobValues(pdfDrawingFileKey, state.partNumberDrawingBlobMap),
      }
  })),
  on(loadPartNumberDrawingBlobSuccess, (state, { pdfDrawingFileKey, blob }): BuildKitPartNumberState => ({
    ...state,
    partNumberDrawingBlobMap: {
      ...state.partNumberDrawingBlobMap,
      [pdfDrawingFileKey]: {
        blob: blob,
        completed: true,
        inProgress: false,
        previousCallInProgress: false
      },
    }
  })),
  on(loadPartNumberDrawingBlobFailure, (state, { error }): BuildKitPartNumberState => ({
    ...state,
    error: error,
  })),
);

function addOrUpdateBuildKitPartNumbers(state: BuildKitPartNumberState, buildKitPartNumber: BuildKitPartNumber){
  return [...state.buildKitPartNumbers, buildKitPartNumber];
}

function partNumberDrawingBlobValues(pdfDrawingFileKey: string, partNumberDrawingBlobMap: any){
  if(pdfDrawingFileKey in partNumberDrawingBlobMap){
    return {
      ...partNumberDrawingBlobMap[pdfDrawingFileKey],
      previousCallInProgress: partNumberDrawingBlobMap[pdfDrawingFileKey].inProgress
    };
  } else {
    return {
      blob: undefined,
      inProgress: true,
      previousCallInProgress: false,
      completed: false,
    }
  }
}

// So we want to check if inProgress = true && previousCallInProgress = false && completed = false

// If partId Not in Map make api call
